export const MAIN_CONTENT_ID = "main-content";
export const JUMP_LINK_PREFIX = "jump-link-";
export const BANNER_COOKIE_PREFIX = "banner-";
export const OFFER_COOKIE_PREFIX = "offer-";
export const GENERATOR_MODAL_COOKIE_PREFIX = "generator-modal-";
